// RouteGuard — نسخة Outlet من RequirePermission (منقولة من frontend/src/routers/RouteGuard.js)
// تُستخدم كعنصر وسيط في تعريف المسارات المركزيّ.
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { hasPagePermission, isSystemAdminSession } from '../lib/accessControl';
import type { Permission } from '../lib/accessControl';
import { PERMISSIONS_BOOTSTRAP_KEY, PERMISSIONS_UPDATED_EVENT, readJsonStorage, readStorage } from '../lib/storage';

function useGateDecision() {
	const location = useLocation();
	const [, forceUpdate] = useState(0);
	const [bootstrapping, setBootstrapping] = useState(() => readStorage(PERMISSIONS_BOOTSTRAP_KEY) === '1');

	useEffect(() => {
		const onPermissionsUpdated = () => {
			setBootstrapping(false);
			forceUpdate((value) => value + 1);
		};
		const timer = window.setTimeout(() => setBootstrapping(false), 4000);
		window.addEventListener(PERMISSIONS_UPDATED_EVENT, onPermissionsUpdated);
		return () => {
			window.clearTimeout(timer);
			window.removeEventListener(PERMISSIONS_UPDATED_EVENT, onPermissionsUpdated);
		};
	}, []);

	const perms = readJsonStorage<Permission[]>('permissions', []);
	const allowed = isSystemAdminSession() || hasPagePermission(perms, [], location.pathname);
	const pending = !allowed && Boolean(readStorage('role_id')) && (bootstrapping || readStorage(PERMISSIONS_BOOTSTRAP_KEY) === '1');

	return { allowed, pending };
}

export function RouteGuardOutlet() {
	const { allowed, pending } = useGateDecision();
	if (pending) return null;
	return allowed ? <Outlet /> : <Navigate to="/no-access" replace />;
}
